import React, { useState } from "react";
import { FreeTrail } from "./FreeTrail";
import CheckoutForm from "./CheckoutForm";
export const PaymentV2 = () => {
  const [activeStep, setActiveStep] = useState(1);

  return (
    <div>
      {/*activeStep === 1 && (
        <FreeTrail activeState={(step) => setActiveStep(step)} />
      ) */}
      {/*activeStep === 2 && <CheckoutForm />*/}
      <CheckoutForm />
    </div>
  );
};
